module.exports = __webpack_public_path__ + "static/media/AI_4.ed038e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_4.png
// module id = 119
// module chunks = 0